import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadDocumentService {

  // baseAccountURL: string;
  // userAccessURL: string;
  documentStorageUrl:string ;
  // documentsStorageUrl:string = environment.documentStorageUrl;
  constructor(
      private httpService: HttpService,
      private http: HttpClient,
      ) {
      // this.baseAccountURL = environment.apiUrlAccount;
      this.documentStorageUrl = environment.integrationMisc;
      
  }

  getLeadDocumentList(requesBody:{
    LeadId:number;
    LeadName:string;
    PageNumber:number;
    PageSize:number}):Observable<any>{
      const encodedLeadName = encodeURIComponent(requesBody.LeadName);
      const url = `${this.documentStorageUrl}ModuleUpload/Lead?LeadId=${requesBody.LeadId}&LeadName=${encodedLeadName}&PageNumber=${requesBody.PageNumber}&PageSize=${requesBody.PageSize}`;
      return this.http.get(url, { observe: 'response' });
}

leadsDocumentsUpload(requesBody):Observable<any[]>{
  return this.httpService.post(this.documentStorageUrl + 'ModuleUpload/Lead',requesBody);
}

deleteLeadDocument(attachmentId:number){
  return this.httpService.delete(this.documentStorageUrl + `ModuleUpload/${attachmentId}`);
}

downloadFilesAndFolder(data:{
  id:number;
  isDefaultContentType :boolean
}):Observable<any>{
  return this.httpService.getById(this.documentStorageUrl + `ModuleUpload/Download/${data?.id}?isDefaultContentType=${data?.isDefaultContentType}`);
}

editLeadDocument(data:{
  attachmentId:number,
  name:string
}){
  return this.httpService.update(this.documentStorageUrl + "ModuleUpload",data);
}
}
